module.exports = __webpack_public_path__ + "static/img/title_img1.c5109fd.svg";


//////////////////
// WEBPACK FOOTER
// ./static/imgs/VXImage/title_img1.svg
// module id = tBb6
// module chunks = 0